import React from 'react';
import { useSelector } from 'react-redux';

import { withContent } from 'components/Content';
import { injectVariables } from 'utils/translation';
import { selectAcquisitionVariables } from 'containers/Landing/selectors';
import { getRegionalBrandName } from 'utils/domainHelper';
import { Mobile, Default } from 'components/Media';

import styles from './callBanner.scss';

const CONTENT_KEYS = {
  callContent: 'Content',
};

const CallBanner = ({ content }) => {
  const { callContent } = content;

  const acquisitionVariables = useSelector(selectAcquisitionVariables());
  const regionalBrandName = getRegionalBrandName();
  const text = injectVariables(
    callContent.fields.text,
    regionalBrandName,
    acquisitionVariables,
    '',
  );
  const mobileText = text.split(' / ')[0];

  return (
    <div className={styles.callBanner}>
      <Mobile>
        <p>{mobileText}</p>
      </Mobile>
      <Default>
        <p>{text}</p>
      </Default>
    </div>
  );
};

export default withContent(CONTENT_KEYS)(CallBanner);
